/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

import { reactive } from "vue"

export const authState = reactive({
    isAuthenticated: false,
    user: null,
    authReady: false,
    isBootingSystem: false,
    authPhase: null
})